import { API, axios, SendRequest} from '@/imports-files/pages/clients/candidates/kanban';


export class Kanban extends SendRequest 
{

  async getApplicationsData(client_auth_cookies, job_slug, params, hostName) 
  {
    const url = API.client.kanban.GET_APPLICATIONS_DATA.replace('$job_slug', job_slug)
    try 
    {
      const result = await axios({
        method: 'get',
        url: url,
        headers: {cookie: `Authorization=${client_auth_cookies}`, SLUG: hostName},
        params: params,
      });
      return result;
    } 
    catch (error) 
    {
      return error;
    }
  }

  async filterdKanbanData(job_slug, params){
    const url = API.client.kanban.GET_FILTERED_APPLICATIONS.replace('$job_slug', job_slug)
    const result = await axios.get(url,
                          {
                            params: params,
                            headers: this.customHeaderJSON()
                          },
                          this.setHeaderJSON(),
                          this.setCrossDomainTrue(),
                          this.setCredentialsJSON());
    return result;
  }

  // async getAsyncVideoInterviewPlatforms(client_auth_cookies) {
  //   const url = API.client.jobs.ASYNC_VIDEO_PLATFORMS
  //   try {
  //     const result = await axios({
  //       method: 'get',
  //       url: url,
  //       headers: {cookie: `Authorization=${client_auth_cookies}`},
  //       params: {},
  //     });
  //     return result.data;
  //   } catch (error) {
  //     return error;
  //   }
  // }
  async closeJob(jobId) {
    try {
      const result = await axios.post(API.client.jobs.CLOSE_JOB.replace('$job_id', jobId),
        {},
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async importCandidates(jobId) {
    try {
      let url = API.client.kanban.IMPORT_CANDIDATES.replace('$job_id', jobId) 
      const result = await axios.post(url,
        {
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON(),
        { timeout: 10 * 60 * 1000}
        );
      return result;
    } catch (error) {
      return error;
    }
  }

  async markActiveUnsuccessful(jobId, params) {
    try {
      const result = await axios.put(API.client.kanban.MARK_ACTIVE_UNSUCCESSFUL.replace('$job_id', jobId),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
  async addToJob(jobId, params) {
    try {
      const result = await axios.post(API.client.kanban.ADD_TO_JOB.replace('$job_id', jobId),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
  async sendTechTest(jobId, params, from, application_filter_data) {
    try {
      const result = await axios.post(API.client.kanban.SEND_TECH_TEST.replace('$job_id', jobId),
        {kanban: params, from: from, application_filter_data: application_filter_data},
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async sendVideoQaInterview(jobId, params, from) {
    try {
      const result = await axios.post(API.client.kanban.SEND.replace('$job_id', jobId),
        {kanban: params, from: from},
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async moveCandidates(jobId, params) {
    try {
      const result = await axios.post(API.client.kanban.MOVE_CANDIDATES.replace('$job_id', jobId),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async runAutomations(jobId, params){
    try {
      const result = await axios.post(API.client.kanban.RUN_AUTOMATION.replace('$job_id', jobId),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async createOffer(params){
    try {
      const result = await axios.post(API.client.offer.CREATE,
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async updateOffer(params, offerId){
    try {
      const result = await axios.patch(API.client.offer.UPDATE.replace('$offer_id', offerId),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async getOfferDetail(params){
    const url = params.job_application_id ? API.client.offer.NEW : API.client.offer.EDIT.replace('$offer_id', params.id)
    try {
      const result = await axios.get(url,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async unsuccessfulReasons(params){
    try {
      const result = await axios.get(API.client.kanban.UNSUCCESSFUL_REASONS,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async scoreCards(job_application_id){
    try {
      const result = await axios.get(API.client.kanban.GET_SCORE_CARDS.replace('$job_application_id', job_application_id),
        {
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async singleScoreCards(job_application_id, scorecard_id){
    try {
      const result = await axios.get(API.client.kanban.GET_SCORE_CARDS.replace('$job_application_id', job_application_id),
        {
          headers: this.customHeaderJSON(),
          params: {scorecard_id: scorecard_id}
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error) {
      return error;
    }
  }

  async compareScoreCards(job_id, params){
    try {
      const result = await axios.post(API.client.kanban.COMPARE_SCORECARDS.replace('$job_id', job_id),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async reviewAutomationEmail(job_id, params){
    try {
      const result = await axios.get(API.client.jobs.REVIEW_AUTOMATION_EMAIL.replace('$job_id', job_id),
        {
          headers: this.customHeaderJSON(),
          params: params
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async sendUnsuccessfulEmail(job_id, params){
    try {
      const result = await axios.post(API.client.kanban.SEND_UNSUCCESSFUL_EMAIL.replace('$job_id', job_id),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async sendOffer(params){
    try 
    {    
      const result = await axios.post(API.admins.dashboard.clients.offers.SEND_OFFER.replace('$offer_id', params.id),
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
      return result;
    } 
    catch (error) 
    {
      return error;
    }
  }

  async checkNotSent(args) {
    try {
      const result = await axios.post(API.client.jobs.MANUAL_NOT_SENT_DATA,
          args,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async sendQuestions(jobId, args) {
    try {
      const result = await axios.post(API.client.kanban.SEND_QUESTIONS.replace('$job_id', jobId),
          args,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async syncNowHiredDataService(jobId, args) {
    try {
      const result = await axios.post(API.client.kanban.HIRED_SYNC_DATA.replace('$job_id', jobId),
          args,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

}